/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const GreaterThanOrEqualFilesize: core.serialization.ObjectSchema<
    serializers.GreaterThanOrEqualFilesize.Raw,
    Truvity.GreaterThanOrEqualFilesize
> = core.serialization.object({
    value: core.serialization.number(),
});

export declare namespace GreaterThanOrEqualFilesize {
    export interface Raw {
        value: number;
    }
}
